import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex } from 'antd';
import OrderService from "services/order"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate } from 'react-router';
import _ from "lodash"
const service = new OrderService();
const { Search } = Input;
const OrderList = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        loadData();
    }, [])
    const loadData = async (info) => {
        var lst = await service.list({ info: info });
        setData(lst);
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500));

    const onSearch = () => {
        delaySearch();
    }


    const columns = [
        {
            title: 'Mã đơn hàng',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <Button type='text' onClick={e => navigate(`/order/${record.id}`)}>
                            {record.id}
                        </Button>
                        <div>
                            {formatDate(record.create_on)}
                        </div>
                    </Space>
                )

            }
        },

        {
            title: 'Khách hàng',

            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            {record.customer?.phone}
                        </div>
                        <div>
                            {record.customer?.full_name}
                        </div>
                    </Space>
                )


            }
        },
        {
            title: 'Sản phẩm',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <div>
                            {record.total_item}
                        </div>
                        <div>
                            {formatCurrency(record.total_amount)}
                        </div>
                    </Space>
                )


                return record.total_item
            }
        },
        {
            title: 'Trạng thái',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <div>
                            {record.payment_status.title}
                        </div>
                        <div>
                            {record.shipping_status.title}
                        </div>
                    </Space>
                )


                return record.total_item
            }
        },


    ];

    return (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card style={{ width: "100%" }}>
                <Space direction='vertical' style={{ width: "100%" }}>


                    <Search
                        placeholder="Mã đơn hàng"
                        onSearch={onSearch}

                        onChange={e => delaySearch(e.target.value)}
                        style={{
                            width: "100%",
                        }}
                    />
                    <Flex justify='flex-end'>
                        <Button type='primary' onClick={e => navigate("/order/add")}>Thêm mới</Button>
                    </Flex>
                </Space>
            </Card>
            <Card style={{ width: "100%" }}>
                <Table dataSource={data} columns={columns} />
            </Card>
        </Space>
    )
}

export default OrderList;
